







import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Student } from '@/modules/student';

@Component
export default class StudentSelect extends Vue {
  @Prop() private student: Student;

  get studentId(): string {
    if (!this.student) {
      return '';
    } else {
      return this.student.id;
    }
  }

  get studentName(): string {
    if (!this.student) {
      return '';
    } else {
      return `${this.student.lastName}　${this.student.firstName}`;
    }
  }

  get schoolName(): string {
    if (!this.$store.state.me.user) {
      return '';
    } else {
      return this.$store.state.me.user.schoolName;
    }
  }

  @Watch('student')
  private changeStudent() {
    this.$nextTick(() => {
      this.drawQRCode();
    });
  }

  private async mounted() {
    await this.drawQRCode();
  }

  private async drawQRCode() {
    const imageType = 'image/png';
    const qrCanvas = (this.$refs.qrcode as Vue).$el.firstElementChild as HTMLCanvasElement;
    const qrBase64 = qrCanvas.toDataURL(imageType);

    const canvas = this.$el.getElementsByClassName('qr-card')[0] as HTMLCanvasElement;
    canvas.height = 260;
    canvas.width = 420;

    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

    let qrLoaded = false;
    let logoLoaded = false;
    const qrImage = new Image();
    qrImage.src = qrBase64;
    qrImage.onload = () => {
      ctx.drawImage(qrImage, 40, 30, 120, 120);
      qrLoaded = true;
    };

    const logoImage = new Image();
    logoImage.src = require('../../assets/logo_large.png');
    logoImage.onload = () => {
      const imgWidth = 100;
      const imgHeight = 100 * logoImage.height / logoImage.width;
      ctx.drawImage(logoImage, 300, 155, imgWidth, imgHeight);
      logoLoaded = true;
    };

    ctx.font = 'normal 16px "Avenir", Helvetica, Arial, sans-serif';
    ctx.fillText(this.student.userId, 220, 70);

    ctx.font = 'bold 20px "Avenir", Helvetica, Arial, sans-serif';
    ctx.fillText(this.studentName, 220, 120, 190);

    ctx.font = 'bold 16px "Avenir", Helvetica, Arial, sans-serif';
    ctx.fillText(this.schoolName, 40, 220, 220);

    while (!qrLoaded || !logoLoaded) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  }
}
